import { Button, SwipeableDrawer } from '@mui/material'
import { POSITION_DRAW } from 'constants/ui.contants'
import { Fragment, useState } from 'react'

/**
 * Component Hiển thị Drawer theo vị trí chỉ định
 * left | right | top | bottom
 * @param {*} param0 
 * @returns 
 */
const SwipePage = ({ children, titleBtn, position = POSITION_DRAW.LEFT }) => {

    const [ open, setOpen] = useState(false)

    return (
        <Fragment>
            <SwipeableDrawer
                anchor={position}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={()=>{}}
            >
                {children}
            </SwipeableDrawer>
            <Button variant='text' onClick={() => setOpen(true)}>{titleBtn || 'Nâng cao'}</Button>
        </Fragment>
    )
}

export default SwipePage